export default __webpack_public_path__ + "static/media/small-clip.a885aeb8.svg";